// Localities list — Session C migration to the FwTable pattern.
// Same request shape as the AgTable page it replaces; columns from
// agModule.json; permission gates unchanged.
import ModuleListPage from "elements/Table/ModuleListPage";

export default function List() {
  return (
    <ModuleListPage
      module="localities"
      title="Localities"
      api="admin/locality"
      url="locality"
      columnsKey="localities"
      quickKey="name"
      quickPlaceholder="Filter by name…"
      perms={["lor", "loc", "lou", "lod"]}
    />
  );
}
